import { render, staticRenderFns } from "./addDiscount.vue?vue&type=template&id=edca9fbe&scoped=true&"
import script from "./addDiscount.vue?vue&type=script&lang=js&"
export * from "./addDiscount.vue?vue&type=script&lang=js&"
import style0 from "./addDiscount.vue?vue&type=style&index=0&id=edca9fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edca9fbe",
  null
  
)

export default component.exports